export enum ReferralType {
  SELF_REFERRAL = 'self_referral',
  FINANCIAL_ADVISOR_REFERRAL = 'financial_advisor_referral'
}
